<template>
    <div><!-- 計畫主檔明細資料 -->
        <CCard>
            <CCardBody>
                <div class="d-flex justify-content-end mb-2">
                    <button class="btn btn-sm btn-edit" @click="savedDataEvent()">{{$t('Buttons.SavedData')}}</button>
                    <button class="btn btn-sm btn-danger ml-2"  v-if="isQMmanager" @click="deleteEvent()">{{$t('Buttons.Delete')}}</button>
                    <button class="btn btn-sm btn-dark ml-2" @click="goBack()">{{$t('Buttons.GoBack')}}</button>
                </div>

                <div class="info">
                    <div class="row">
                        <div class="col-md-2">{{$t('QualityInfo_Vue.FactoryType')}}</div>
                        <div class="col-md-10">{{planMasterRow.factoryName}}</div>
                    </div>
                    <div class="row">
                        <div class="col-md-2">{{$t('QualityInfo_Vue.RoeModel')}}</div>
                        <div class="col-md-10">{{planMasterRow.roeModel}}</div>
                    </div>
                    <div class="row">
                        <div class="col-md-2">{{$t('QualityInfo_Vue.DevelopPhase')}}</div>
                        <div class="col-md-10">{{planMasterRow.developPhase}}</div>
                    </div>
                    <div class="row">
                        <div class="col-md-2">{{$t('QualityInfo_Vue.Project')}}</div>
                        <div class="col-md-10">{{planMasterRow.project}}</div>
                    </div>
                    <div class="row">
                        <div class="col-md-2">{{$t('QualityInfo_Vue.DemandDate')}}</div>
                        <div class="col-md-10">{{fixDateTime(planMasterRow.demandDate)}}</div>
                    </div>
                </div>
                <table class="table table-bordered">
                    <thead class="thead-light">
                        <tr>
                            <th class="text-center">{{headers[0]}}</th>
                            <th class="text-center">{{headers[1]}}</th>
                            <th class="text-center">{{headers[2]}}</th>
                            <th class="text-center">{{headers[3]}}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item , index) in planMasterRow.detailList" :key="index">
                            <td class="text-center">{{planMasterRow.factoryName}}</td>
                            <td class="text-center">{{item.partnumber}}</td>
                            <td class="text-center">{{item.partname}}</td>
                            <td class="text-center btn-center">
                                {{item.customerName}}
                                <button class="btn btn-sm btn-success ml-2" @click="maintainEvent(item)" data-toggle="modal" data-target="#addVendorModal-QM" >{{$t('Buttons.Maintain')}}</button>
                            </td>
                        </tr>                        
                    </tbody>
                </table>
            </CCardBody>
        </CCard>
        <!-- 新增廠商挑選區塊 -->
        <PersonSelect @updateVendors="updateVendors" :factoryId="planMasterRow.werks" :vendorList="hadVendorList" :vendorType="'-QM'"/>   
    </div>
</template>
<script>
import { qualityMixin } from '@/mixin/quality'
import PersonSelect from '../Purchase/PurchaseEdit/PersonSelect.vue'
import { mapGetters } from 'vuex'
export default {
    mixins: [qualityMixin],	
    components: {        
        PersonSelect
    },
    data() {
        return {
            headers:[
                this.i18n('PlanMasterFile.Factory'),this.i18n('PlanMasterFile.PartNumber'),this.i18n('PlanMasterFile.Parts'),this.i18n('PlanMasterFile.Vendor')
            ],            
            planMasterRow: {detailList: []},   
            hadVendorList : [],
            currentMaintainItem: null
        }
    },
    props : {
    },
    watch: {
        "lang": function() {
            this.headers = [
                this.i18n('PlanMasterFile.Factory'),this.i18n('PlanMasterFile.PartNumber'),this.i18n('PlanMasterFile.Parts'),this.i18n('PlanMasterFile.Vendor')
            ]
        }
    },
    methods: {        
        deleteEvent (){//刪除
            const item= this.planMasterRow;
            if(item.isDelete !== true && this.isQMmanager){
                const self =this;
                this.$confirm('此操作將永久刪除該筆資料, 是否繼續?', '提示', {
                confirmButtonText: '確定',
                cancelButtonText: '取消',
                type: 'warning'
                }).then(() => {
                    self.doDeleteRow(item);
                });
            }
        },
        doDeleteRow (item){//呼叫刪除處理
            const url = `${this.$apiUrl_Quality}/DeletePlanMasterRow`;
            this.updateLoading(true);
            const param = { pid: item.pid};
            this.axios.post(url, param).then((response) => {
                const {status , statusMessage} = response.data;
                this.updateLoading(false);
                if(status){
                    this.$alert(statusMessage,'警告',{type: 'warning'});
                }else{                    
                    //--成功          
                    item.isDelete =true;
                    this.goBack();
                }                    
            }); 
        },
        getDetail(guid) {//目前編輯的計畫主檔明細資料
            const url = `${this.$apiUrl_Quality}/GetPlanMasterDetail/${guid}`
            this.updateLoading(true)
            this.axios.get(url).then((response) => {                
                this.planMasterRow = response.data;
                this.updateLoading(false)
            })
        },
        goBack (){
            this.$router.go(-1);
        },
        savedDataEvent (){//呼叫儲存處理
            const url = `${this.$apiUrl_Quality}/UpdatePlanMasterRow`;
            const item = this.planMasterRow ;            
            if(item.detailList && item.detailList.length === 0){
                this.goBack();
                return;
            }
            const detailList = [];
            item.detailList.forEach(e=>{
                const r = {pid:e.pid , seqno:e.seqno , vendor: e.vendor };
                detailList.push(r);
            })            
            this.updateLoading(true);
            const param = { pid: item.pid , detailList : detailList};
            this.axios.post(url, param).then((response) => {
                const {status , statusMessage} = response.data;
                this.updateLoading(false);
                if(status){
                    this.$alert(statusMessage,'警告',{type: 'warning'});
                }else{                                        
                    this.goBack();
                }                    
            }); 
        },
        maintainEvent (item){//維護
            if(item){   
                this.currentMaintainItem = item;
                this.hadVendorList.splice(0);
                this.hadVendorList.push({vendorId: item.vendor});
                return true;
            }else{
                return false;
            }
        },
        updateVendors (selectedList){            
            if(this.currentMaintainItem && selectedList && selectedList.length >0){
                const item = selectedList[0];
                this.currentMaintainItem.vendor = item.vendorId;
                this.currentMaintainItem.customerName = item.vendorName;
            }
        },
        i18n (keyStr){
            return this.$t(keyStr);
        },
    },
    computed: {
        ...mapGetters(['lang'])
    },
	mounted() {
        let planMasterId = sessionStorage.getItem('planMasterId');        
        if(planMasterId){
            this.getDetail(planMasterId);
        }        
	},
    created() {        
    }
}
</script>
<style lang="scss" scoped>
.btn-edit {
    background-color: #343b55;
    color: white;
}
table th:first-child {
    text-align: center;
    padding: 15px 5px;
}
.table th {
    // background-color: #FFC300;
    background-color: #FFD966;
    color: #000;
}
.table tr:nth-child(even) {
    background-color: transparent;
}
.table tr.table-close {
    background-color: #D0D0D0;
}
.btn-center {
    display: flex;
    align-items: center;
    justify-content: center;
    // border-top: none;
    border: none;
    // height: 67px;
}
.info {
    border: solid 1px #000;

    .row {
        margin: 0;
        border-bottom: solid 1px #000;
        .col-md-2, .col-md-10 {
            // margin: 5px;
            padding: 0;
            padding: 1rem;
        }
        .col-md-2 {
            font-weight: 900;
            background-color: #BDD6EE;
        }
        .col-md-10 {
            border-left: solid 1px #000;
            // #d8dbe0
        }
    }
        
}
.table, .table-bordered th, .table-bordered td {
    border-color: black;
}

.table, .table-bordered th {
    border-top: none;
}
</style>




